export const PRODUCT_BADGE_LABELS = ["New", "Bestseller", "Trending"];

const PRODUCT_BADGE_PRIORITY = PRODUCT_BADGE_LABELS.reduce(
  (priority, label, index) => {
    priority[label.toLowerCase()] = index;
    return priority;
  },
  {}
);

function normalizeBadgeLabel(label) {
  const normalized = label.trim().toLowerCase();

  return PRODUCT_BADGE_LABELS.find(
    (allowedLabel) => allowedLabel.toLowerCase() === normalized
  );
}

/**
 * Returns product card badges from Shopify tags.
 * Supported tags: `badge: New`, `badge: Bestseller`, `badge: Trending`
 * Only the highest-priority badge is shown when multiple are present.
 */
export function getProductBadges(tags = []) {
  const badges = tags
    .filter((tag) => tag.toLowerCase().trim().startsWith("badge:"))
    .map((tag) => tag.replace(/^\s*badge:\s*/i, ""))
    .map(normalizeBadgeLabel)
    .filter(Boolean);

  if (!badges.length) {
    return [];
  }

  const highestPriorityBadge = badges.sort(
    (a, b) =>
      PRODUCT_BADGE_PRIORITY[a.toLowerCase()] -
      PRODUCT_BADGE_PRIORITY[b.toLowerCase()]
  )[0];

  return [highestPriorityBadge];
}
